import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import gsap from 'gsap';

function initQuoteSlider() {

    let swiper = new Swiper(".quote-wrapper-items", {
        effect: "fade",
        centeredSlides: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        speed: 1000,
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            disableOnInteraction: false
        }
    });
}

function initClipPathAnimation() {
    gsap.to('.quote-section', {
            keyframes: [
                {clipPath: 'polygon(100% 100%, 100% 0%, 100% 100%, 0% 100%)'},
                {clipPath: 'polygon(100% 100%, 100% 0%, 0 100%, 0% 100%)'},
                {clipPath: 'polygon(100% 100%, 100% 0%, 0% 0%, 0% 100%)'}
            ],
            duration: 1,
            scrollTrigger: {
                trigger: '.quote-section',
                start: 'top bottom-=20%',
                end: 'top bottom-=20%',
                once: true
            }
        }
    )
}

export function initQuoteSection() {
    initQuoteSlider();
    initClipPathAnimation();
}